/**
* DevExpress Dashboard (_layout-dimension-options.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { floatFromModel } from '../../metadata/_base-metadata';
export const _defaultHeight = 800;
export const _defaultWidth = 1000;
let mode = { propertyName: 'mode', modelName: '@Mode', values: {
        'Auto': 'DashboardStringId.LayoutDimensionModeAuto',
        'Fixed': 'DashboardStringId.LayoutDimensionModeFixed',
    }, defaultVal: 'Auto' };
let height = { propertyName: 'value', modelName: '@Value', defaultVal: _defaultHeight, from: floatFromModel };
let width = { propertyName: 'value', modelName: '@Value', defaultVal: _defaultWidth, from: floatFromModel };
export let heightOptionsSerializationInfo = [mode, height];
export let widthOptionsSerializationInfo = [mode, width];
